import { USER_ACTIVITY } from '../types';

const userActivity = isActive => ({
  type: USER_ACTIVITY, isActive,
});

export default userActivity;
